const signInRedirectPage = {
  fr: {
    signInRedirectPage: {
      title: 'Connexion',
      message: 'Veuillez patienter...',
    },
  },
  en: {
    signInRedirectPage: {
      title: 'Signing In',
      message: 'Please wait...',
    },
  },
};

export default signInRedirectPage;
